import { render, staticRenderFns } from "./SalesFarmerPopup.vue?vue&type=template&id=321b07a8&scoped=true"
import script from "./SalesFarmerPopup.vue?vue&type=script&lang=js"
export * from "./SalesFarmerPopup.vue?vue&type=script&lang=js"
import style0 from "./SalesFarmerPopup.vue?vue&type=style&index=0&id=321b07a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b07a8",
  null
  
)

export default component.exports